import axios from 'axios';
import router from '@/router';
import { useToast } from 'vue-toastification';
const toast = useToast();

// Устанавливаем базовый URL из переменных окружения
axios.defaults.baseURL = import.meta.env.VITE_BACKEND_URL+import.meta.env.VITE_API_VER.replaceAll('.', '_');

// Функция для обновления токена
const refreshToken = async () => {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token available');
  }

  try {
    const response = await axios.post('/auth/token/refresh', {
      refresh_token: refreshToken
    });

    console.log('refresh response', response);

    const { access_token: newAccessToken, refresh_token: newRefreshToken } = response.data;

    if (newAccessToken) {
      localStorage.setItem('accessToken', newAccessToken);
    }
    if (newRefreshToken) {
      localStorage.setItem('refreshToken', newRefreshToken);
    }

    return newAccessToken;
  } catch (error) {
    throw new Error('Token refresh failed');
  }
};

// Добавляем интерцептор для установки заголовка авторизации и обработки ошибок
axios.interceptors.request.use(
  (config) => {
    // Получаем токен из localStorage
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    else {
      config.headers.Authorization = null;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    console.log(response);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    console.log(error);
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      console.log('error 400-500');
      if (error.response.data.error_type == 'error') {
        console.log('error type error');
        if (error.response.data.message) {
          console.log('error message', error.response.data.message);
          let timeout=3000;
          if (error.response.data.auto_close==false) timeout=0;
          toast.error(error.response.data.message, {timeout: timeout});
        }
      }
    }
    if (error.response && error.response.status === 401) {
      try {
        console.log(error);
        if (error.config.url == "/auth/token/refresh") {
          throw new Error('Token refresh failed');
          return;
        }
        console.log('url', error.config.url);


        // Попытка обновления токена
        const newAccessToken = await refreshToken();
        console.log('newAccessToken', newAccessToken);

        // Обновление заголовка авторизации в оригинальном запросе
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

        // Повторный запрос с новым токеном
        return axios(originalRequest);
      } catch (refreshError) {
        // Очистка данных и переадресация на страницу входа при неудачном обновлении токена
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        router.push('/login');
        //window.location.replace('/login');
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

const HttpPlugin = {
  install(app, options) {

    console.log('Axios baseURL:', axios.defaults.baseURL);

    // Добавляем методы для запросов в глобальный Vue экземпляр
    app.config.globalProperties.$requests = {
      get(url, config) {
        return axios.get(url, config);
      },
      post(url, data, config) {
        return axios.post(url, data, config);
      },
      put(url, data, config) {
        return axios.put(url, data, config);
      },
      patch(url, data, config) {
        return axios.patch(url, data, config);
      },
      delete(url, config) {
        return axios.delete(url, { data: config });
      }
    };
  }
};

export default HttpPlugin;
